import styled from "styled-components"
import Button from "@material-ui/core/Button"

export const ProjectListMessage = styled.div`
  width: 100%;
  height: 20rem;
`;

export const ProjectListExplanation = styled.div`
  width: 90%;
  font-size: 15px;
  margin: 0 auto 20px;
  
  & table {
    margin-top: 30px;
  }
    `;

export const HelloTtlConfigColumnHeader = styled.th`
    width: 20%;
    `

export const HelloTtlConfigColumn = styled.td`
    width: 20%;
    `

export const UpdateButton = styled(Button)`
  background-color: blue;
  color: white;
  font-size: 1.4rem;
  height: 2rem;
`;


export const DeleteButton = styled(Button)`
  background-color: blue;
  color: white;
  font-size: 1.4rem;
  height: 2rem;
`;